export abstract class BaseSerializer {
    public static serialize(model: any, omit: any[] = []) {

        const jsonString = JSON.stringify(model, (key, value) => {
            // Check if key matches anything in omit.
            // if matched return value "undefined"
            if (omit.includes(key)) {
                return undefined;
            }
            // else return the value itself
            return value;
        });

        return jsonString;
    }

    abstract deserialize( data: any ): any;

    deserializeList( data: any ): any [] {

        if (data === undefined)
            return [];

        const itemList:any[] = [];

        for (const dataItem of data) {
            const item = this.deserialize(dataItem);
            itemList.push(item);
        }

        return itemList;
    }

    _copyAttributes(target: any, source:any) {
        if (source === null || source === undefined){
            return target;
        }
        Object.keys(target).forEach((key : string) => {
            if (Object.prototype.hasOwnProperty.call(source, key) && source[key] != null && source[key] !== '') {
                    target[key] = source[key];
            }
        });

        return target;
    }

    _copyAttributesDropDown(target: any, source:any) {
        if (source === null || source === undefined){
            return target;
        }
        Object.keys(target).forEach((key : string) => {
            if (Object.prototype.hasOwnProperty.call(source, key) && source[key] != null && source[key] !== '') {
                    if(key == "code")
                        target["value"] = source["code"];
                    else  
                        target["value"] = source["id"];
                    target["label"] = source["value"];
                    
                    
            }
        });

        return target;
    }

    _copyLayersAttributes(target: any, source:any) {
        if (source === null || source === undefined){
            return target;
        }
        Object.keys(target).forEach((key : string) => {
            if (Object.prototype.hasOwnProperty.call(source, key) && source[key] != null && source[key] !== '') {
                   target[key] = source[key];
            }
        });
        // if(source["color_layer"] != null)
        //     target["color_value"] = source["color_layer"]["color_value"];
        const layerKeys = [
            "color_layer",
            "text_layer",
            "video_layer",
            "animation_layer",
            "image_layer",
          ];
          
          for (const key of layerKeys) {
            if (source[key] != null) {
              delete source[key]?.id;
              Object.assign(target, source[key]);
              break; // Exit after the first matching layer
            }
          }

        return target;
    }

}
